import React from 'react';
type EmiratiBadgeProps = {
  compact?: boolean;
};
export function EmiratiBadge({
  compact = false
}: EmiratiBadgeProps) {
  return <span className="inline-flex items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-800" title="UAE National" data-id="element-192" data-mp="2wwoq3w73ultw">
      <UaeFlag data-id="element-193" data-mp="35u8tpbsfwu7o" />
      {!compact && 'Emirati'}
      {compact && <span className="sr-only" data-id="element-194" data-mp="3kk6k7ydudw01">Emirati</span>}
    </span>;
}
function UaeFlag() {
  return <span aria-hidden="true" className="flex h-2.5 w-4 overflow-hidden rounded-[2px] ring-1 ring-black/10" data-id="element-195" data-mp="3fm4q8ievoc9s">
      <span className="h-full w-1 bg-[#EF3340]" data-id="element-196" data-mp="3tlmk3c716fq0" />
      <span className="flex flex-1 flex-col" data-id="element-197" data-mp="3tja4h5oqwhg4">
        <span className="flex-1 bg-[#009739]" data-id="element-198" data-mp="3om1l51rv27da" />
        <span className="flex-1 bg-white" data-id="element-199" data-mp="3ok6z1k4us97m" />
        <span className="flex-1 bg-black" data-id="element-200" data-mp="1z6trlm1g252a" />
      </span>
    </span>;
}